t = require('app/scripts/views/internal/teacup-with-helpers')('board_copy')

module.exports = ->
  t.form ->
    t.div '.board-menu-convert-to-template-container', ->
      t.img '.board-menu-convert-to-template', {
        src: require('resources/images/template-create-popover-icon.svg')
        alt: ""
        role: "presentation"
      }

    t.p ->
      t.format 'make-template-text'
    t.input '.primary.wide.full.js-convert', { type: 'submit', value: t.l('make-template') }
